import { withStyles } from "@material-ui/core/styles";
import {} from "assets/jss/material-dashboard-react.js";
import AssociationList from "components/AssociationList.js";
import Form from "components/MuiJsonForm";
import RowGenerateFile from "components/RowGenerateFile";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Actions from "redux/actions";
import { intendanceColumns } from "utils/columns";
import fileDialog from "utils/fileDialog";
import { intendanceSchema } from "utils/schemas";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import moment from "moment";
import axios from "axios";

class IntendancesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "current",
      markAsRefreshed: null,
    };
    this._isMounted = false;
    this.cancelSources = new Set();
    this.dispatch = this.props.dispatch;
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.cancelAllRequests("IntendancesList unmounted");
  }

  loadData = () => {
    const intentsSource = this.createCancelSource();
    const appartSource = this.createCancelSource();
    const variablesSource = this.createCancelSource();
    this.trackPromise(
      this.dispatch(Actions.getIntendances({ cancelToken: intentsSource.token })),
      intentsSource
    );
    this.trackPromise(
      this.dispatch(Actions.getAppartements({ cancelToken: appartSource.token })),
      appartSource
    );
    this.trackPromise(
      this.dispatch(Actions.getVariables({ cancelToken: variablesSource.token })),
      variablesSource
    );
  }

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb);
    }
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source));
    } else {
      this.releaseCancelSource(source);
    }
    return promise;
  };

  filterIntendance = () => {
    const int = this.props.intendances || [];
    const { filter } = this.state;
    if (filter === "all") return int;
    return int.filter((i) => {
      const end = moment(i.dateFin);
      if (filter === "noRefresh" && !i.renouvele && moment().isAfter(end))
        return true;
      else if (filter === "current" && moment().isBefore(end)) return true;
      else if (filter === "refreshed" && i.renouvele && moment().isAfter(end))
        return true;
      return false;
    });
  };

  getEmptyString = () => {
    const { filter } = this.state;
    switch (filter) {
      case "current":
        return "Aucune mission d'intendance en cours";
      case "noRefresh":
        return "Aucune mission d'intendance non renouvelée";
      case "all":
        return "Aucune mission d'intendance";
      default:
        return "Aucune mission d'intendance";
    }
  };

  render() {
    const c = this.props.classes;
    const { appartements } = this.props;
    return (
      <div className={c.container}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Filtres</FormLabel>
          <RadioGroup
            className="row"
            name="auto"
            value={this.state.filter}
            onChange={(e) => this.updateState({ filter: e.target.value })}
          >
            <FormControlLabel
              value="current"
              control={<Radio />}
              label="En cours"
            />
            <FormControlLabel
              value="noRefresh"
              control={<Radio />}
              label="Non renouvelées"
            />
            <FormControlLabel value="all" control={<Radio />} label="Toutes" />
          </RadioGroup>
        </FormControl>
        <AssociationList
          title=""
          data={this.filterIntendance()}
          actions={[
            (rw) => ({
              icon: "refresh",
              tooltip: rw.renouvele
                ? "Mission déjà renouvelée"
                : "Renouveler la mission d'intendance",
              disabled: rw.renouvele,
              onClick: (event, rowData) => {
                if (!this._isMounted) return;
                this.updateState({
                  FormDataIntendance_New: {
                    appart: { appart: rw.Appartement },
                    data: {
                      ...rw,
                      prixHT: 100,
                      dateDepart: moment(rw.dateDepart)
                        .add(1, "y")
                        .toISOString()
                        .split("T")[0],
                      dateFin: moment(rw.dateFin)
                        .add(1, "y")
                        .toISOString()
                        .split("T")[0],
                      Appartement: undefined,
                      id: undefined,
                      regle: false,
                      renouvele: false,
                    },
                  },
                  markAsRefreshed: rw.id,
                }, this.openTopRight);
              },
            }),
            {
              icon: "home",
              tooltip: "Voir l'appartement concerné",
              onClick: (event, rowData) =>
                this.props.history.push(
                  `/Appartements/${rowData.AppartementId}`
                ),
            },
          ]}
          columns={intendanceColumns}
          detailPanel={(row) => (
            <div style={{ background: "#EEE", padding: 10 }}>
              <RowGenerateFile
                key={row.id}
                title={`Ordre de mission d'Intendance`}
                generateUrl={`Appartement/${row.AppartementId}/ordreMissionIntendance/${row.id}/generate`}
                generateName={`Ordre_Mission_Intendance_Non_Signé.docx`}
                uploaded={row.ordreMission}
                uploadedName={`Ordre_Mission_Intendance.docx`}
                onUpload={(_) =>
                  fileDialog("ordreMission")
                    .then((fd) => this.dispatch(Actions.setIntendance(row.id, fd)))
                    .then((_) => this.loadData())
                }
              />
              <Form
                {...intendanceSchema(
                  row,
                  // () => {},
                  (data) => this.updateState({ ["FormData_" + row.id]: data }),
                  this.readOnly,
                  this.isNew,
                  appartements,
                  this.defaultTVA
                )}
                formData={this.state["FormData_" + row.id]}
                onSubmit={({ formData }) => {
                  this.dispatch(
                    Actions.setIntendance(row.id, {
                      ...formData.data,
                      AppartementId: formData.appart.appart.id,
                    })
                  ).then((_) => this.loadData());
                }}
              />
            </div>
          )}
          onTopRightClose={(_) => this.updateState({ markAsRefreshed: null })}
          forceOpenTopRight={(open) => (this.openTopRight = open)}
          onTopRightButton={(close) => (
            <Form
              {...intendanceSchema(
                {},
                (data) => this.updateState({ FormDataIntendance_New: data }),
                false,
                true,
                appartements,
                20
              )}
              formData={this.state.FormDataIntendance_New}
              onSubmit={({ formData: { data, appart } }) => {
                const proms = [];
                if (this.state.markAsRefreshed !== null)
                  proms.push(
                    Actions.setIntendance(this.state.markAsRefreshed, {
                      renouvele: true,
                    })
                  );
                proms.push(
                  this.dispatch(
                    Actions.createIntendance({
                      ...data,
                      AppartementId: appart.appart.id,
                    })
                  )
                );
                Promise.all(proms).then((_) => {
                  this.loadData();
                  close();
                });
              }}
              onError={() => null}
            />
          )}
          topRightButtonTxt="Nouvelle Mission d'Intendance"
          noDataTxt={this.getEmptyString()}
          removeTxt="Supprimer la mission"
          search={true}
          filtering={true}
          onRemove={(intendanceId) =>
            this.dispatch(Actions.deleteIntendance(intendanceId))
          }
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {},
});

const mapStateToProps = (state) => {
  return {
    intendances: state.reducer.intendances,
    canDelete: state.reducer.canDelete,
    appartements: state.reducer.appartements,
    variables: state.reducer.variables,
  };
};
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(IntendancesList))
);
